module.exports = __webpack_public_path__ + "static/img/sjzm_4.3ffeb14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjzm_4.jpg
// module id = V32w
// module chunks = 1